// extracted by mini-css-extract-plugin
export default {"page_general__main":"PageGeneralMain_page_general__main__-WJIi"};